import React, {useCallback, useEffect, useState} from 'react';
import AdminPanelUI from '../view/AdminPanelUI';
import {inject, observer} from 'mobx-react';
import AdminPanelStore from '../store/AdminPanelStore';
import type {StudioCostQuery} from '../../../data/models/StudioCosts';
import {useNavigate} from 'react-router-dom';

interface Props {
  adminPanelStore?: AdminPanelStore;
}

const AdminPanelContainer = inject('adminPanelStore')(
  observer(({adminPanelStore}: Props) => {
    const navigate = useNavigate();
    const [statistic, setStatistic] = useState<any>();
    const [lastAccess, setLastAccess] = useState<any>();
    const [recentSignups, setRecentSignups] = useState<any[]>([]);
    const [pages, setPages] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [activeSignupsPage, setActiveSignupsPage] = useState(1);
    const [signupsPages, setSignupsPages] = useState(0);

    useEffect(() => {
      adminPanelStore?.getAnalytics().then(res => {
        if (res.data) {
          setStatistic(res.data);
          adminPanelStore!.getLastAccessData(activePage - 1, 10).then(res => {
            setLastAccess(res.data);
            setPages(res.pagesCount);
          });
          adminPanelStore!
            .getRecentSignups(activeSignupsPage - 1, 10)
            .then(res => {
              setRecentSignups(res.data);
              setSignupsPages(res.pagesCount);
            });
        } else {
          navigate('/', {replace: true});
        }
      });
    }, [activePage, activeSignupsPage]);

    const loadStudioCosts = useCallback(
      (query: StudioCostQuery) => adminPanelStore!.getStudioCosts(query),
      [adminPanelStore],
    );

    const logout = () => {
      adminPanelStore!.logout().then(() => {
        navigate('/', {replace: true});
      });
    };

    return (
      <AdminPanelUI
        statistic={statistic}
        logout={logout}
        lastAccess={lastAccess}
        onPageChange={setActivePage}
        pages={pages}
        signups={recentSignups}
        signupPages={signupsPages}
        onSignupPageChange={setActiveSignupsPage}
        loadStudioCosts={loadStudioCosts}
      />
    );
  }),
);
export default AdminPanelContainer;
